import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query getOrder($ids: [String], $for_admin: Int) {
        order(ids: $ids, for_admin: $for_admin) {
          data {
            status_timeline {
              created_at
              status {
                id
                title
              }
              user {
                id
                firstname
                lastname
                cellphone
              }
            }
          }
        }
      }
    `,
  },
};

export default schema;
